import { Children, cloneElement } from 'react';

import { usePopoverContext } from './context';

import type { FC, ReactElement } from 'react';

export interface PopperOnClickCloseProps {
  children: ReactElement | ReactElement[];
}

export const PopoverOnClickClose: FC<PopperOnClickCloseProps> = ({
  children,
  ...props
}) => {
  const { handleClose } = usePopoverContext();

  return (
    <>
      {Children.map(children, (child) =>
        cloneElement(child, {
          onClick: handleClose,
          ...props,
        })
      )}
    </>
  );
};
